// extracted by mini-css-extract-plugin
module.exports = {"Link":"banner_Link__C4aOj","MobileBanner":"banner_MobileBanner__37ks_","Banner":"banner_Banner__wWybK"};